<template>
  <div class="carousel_wrap">
    <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in mediaList" :key="index">
        <video autoplay loop muted playsinline class="media_item">
          <source :src="item.src" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div class="tips_font" data-aos="fade-up">
          <p>{{ item.line1 }}</p>
          <p class="subtitle">{{ item.line2 }}</p>
          <a href="/home">
            <p>了解更多 >></p>
            <i class="iconfont icon-jiantou"></i>
          </a>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in mediaList" :key="index">
        <video autoplay loop muted playsinline class="media_item">
          <source :src="item.src" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div class="tips_font" data-aos="fade-up">
          <h1>{{ item.line1 }}</h1>
          <h1 class="subtitle">{{ item.line2 }}</h1>
          <a href="/home">
            <p>了解更多 >></p>
            <i class="iconfont icon-jiantou"></i>
          </a>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mediaList: [
        {
          src: require('@/assets/videos/banner1.mp4'),
          line1: '追求卓越，开拓创新',
          line2: 'Pursuing excellence and exploring innovation',
        },
        {
          src: require('@/assets/videos/banner2.mp4'),
          line1: '细微之处，心随势动',
          line2: 'Subtle details, the heart moves with the trend',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;
  .el-carousel__container {
      height: 100vh !important;
	  @media screen and (max-width: 768px) {
	  	  height: 50vw !important;
	  }
  }
  .el-carousel__item {
    .media_item {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 330px;
    left: 330px;
    z-index: 5;
    color: #fff;
    font-size: 52px;
	.subtitle {
      font-size: 15px;
	  letter-spacing: 1px;
	  display: flex;
	  grid-column-gap: 5px;
	}
	a {
      font-size: 18px;
      display: block;
      margin-top: 56px;
      justify-content: space-between;
      color: #fff;
      height: 45px;
      align-items: center;
      cursor: pointer;
	}
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>